import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import fetch from './../../fetch'
import { baseURL, commonHeaders } from '../../../../Containers/Confiq/index.js'

import {
  GET_COUPON_PARTNER,
  GET_COUPON_PARTNER_SUCCESS,
  GET_COUPON_PARTNER_ERROR,
} from './../../actionType.js'

function* getPartner({ payload }) {
  try {
    const response = yield call(fetch, {
      url: `${baseURL}/parse/classes/golfbookings/?where=${payload.param}`,
      method: 'GET',
      // headers: { ...commonHeaders },
    })

    if (response?.error === undefined) {
      yield put({ type: GET_COUPON_PARTNER_SUCCESS, payload: response })
    } else {
      yield put({ type: GET_COUPON_PARTNER_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: GET_COUPON_PARTNER_ERROR, payload: error })
  }
}

export function* watchGetPartner() {
  yield takeEvery(GET_COUPON_PARTNER, getPartner)
}

function* getCouponPartnerSaga() {
  yield all([fork(watchGetPartner)])
}

export default getCouponPartnerSaga
